import React from "react";

const PartnerHeader = () => {
  return (
    <>
      <div className="phead_top">
        <div className="partner_header">
          <h2>Partners</h2>
        </div>
      </div>
    </>
  );
};

export default PartnerHeader;
